module.exports = __webpack_public_path__ + "static/media/IMG_2213.d43eedff.JPG";